import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from './axios'

/**
 * 
 * @param {*string} actionType 
 * @param {*string | function} url 
 * @param {*string} method 
 * @returns {thunk}
 */
export const asyncRequest = (actionType, url, method) => createAsyncThunk(actionType, async (objData, { rejectWithValue }) => {
  let endpoint;

  if (typeof url === 'string') {
    endpoint = url
  } else if (typeof url === 'function') {
    endpoint = url(objData)
  }
  
  try {
    const { data } = await axios[method](endpoint, ['get', 'delete'].includes(method) ? {} : objData);
    return data;
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})